var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FormControl as MuiFormControl, FormLabel as MuiFormLabel } from '@mui/material';
import React, { useId } from 'react';
import { ThemeUtils, getAttributes } from '../../../utils';
import { Checkbox } from '../../atoms/checkbox';
import { Container, ContainerDisplays, ContainerFlexDirections, ContainerFlexGaps, ContainerFlexWraps, ContainerPaddings } from '../../templates/container';
import { InputMessages } from '../common/input-messages';
import { CheckboxGroupOrientations } from './types';
var CheckboxGroup = function (_a) {
    var props = __rest(_a, []);
    var className = props.className, title = props.title, id = props.id, name = props.name, required = props.required, _b = props.checkboxList, checkboxList = _b === void 0 ? [] : _b, helperText = props.helperText, successHint = props.successHint, errorHint = props.errorHint, row = props.row, designStyle = props.designStyle, onCheckboxChange = props.onChange, rest = __rest(props, ["className", "title", "id", "name", "required", "checkboxList", "helperText", "successHint", "errorHint", "row", "designStyle", "onChange"]);
    var messageHintId = useId();
    var formControlProps = __assign({ id: id, error: Boolean(errorHint) }, getAttributes(rest));
    var checkboxListContainerConfig = {
        'aria-describedby': messageHintId,
        display: ContainerDisplays.Flex,
        flexDirection: row === CheckboxGroupOrientations.Horizontal
            ? ContainerFlexDirections.Row
            : ContainerFlexDirections.Column,
        flexWrap: ContainerFlexWraps.Wrap,
        flexGap: ContainerFlexGaps.Size_2
    };
    var inputMessagesProps = {
        id: messageHintId,
        helperText: helperText,
        successHint: successHint,
        errorHint: errorHint
    };
    var paddingTitle = ThemeUtils.getResponsiveProp([
        {
            b: ContainerPaddings.Size_3
        }
    ]);
    return (React.createElement(MuiFormControl, __assign({ role: "group" }, formControlProps),
        title && (React.createElement(MuiFormLabel, { required: required },
            React.createElement(Container, { padding: paddingTitle }, title))),
        React.createElement(Container, __assign({}, checkboxListContainerConfig), checkboxList === null || checkboxList === void 0 ? void 0 : checkboxList.map(function (checkbox, index) { return (React.createElement(Checkbox, __assign({ key: "checkbox-".concat(checkbox.label || checkbox.text, "-").concat(index), label: checkbox.label, text: checkbox.text, onMouseOver: checkbox.onMouseOver, onMouseLeave: checkbox.onMouseLeave, onFocus: checkbox.onFocus, onBlur: checkbox.onBlur, designStyle: checkbox.designStyle || designStyle, onChange: function (e) {
                onCheckboxChange === null || onCheckboxChange === void 0 ? void 0 : onCheckboxChange(e, index);
            }, color: checkbox.color, checked: checkbox.checked, disabled: checkbox.disabled, readOnly: checkbox.readOnly, error: checkbox.error, value: checkbox.value, icon: checkbox.icon, checkedIcon: checkbox.checkedIcon }, getAttributes(checkbox)))); })),
        React.createElement(InputMessages, __assign({}, inputMessagesProps))));
};
export { CheckboxGroup };
